import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Concurso from "../views/concursos/Concurso.vue";
import Clientes from "../views/clientes/Clientes.vue";
import AtivarConta from "../views/ativar/Ativar.vue";
import Estatisticas from "../views/estatistica/Estatisticas.vue";
import Socios from "../views/socios/Socios.vue";
import Signup from "../views/signup/Signup.vue";
import ResetPassword from "../views/resetpassword/ResetPassword.vue";
import Login from "../views/login/login.vue";
import Forbidden from "../views/forbidden/Forbidden.vue";
import ConcursoLj from "../views/concursolj/ConcursoLj.vue";
import Empresa from "../views/empresa/Empresa.vue";
import Saque from "../views/saque/Saque.vue";
import Conciliacao from "../views/conciliacao/Conciliacao.vue";
import Padroes from "../views/padroes/Padroes.vue";
import Caixa from "../views/caixa/Caixa.vue";
import RelatorioAposta from "../views/relatorios/RelatorioApostas.vue";
import RelatorioCaixa from "../views/relatorios/RelatorioCaixa.vue";
import RelatorioPremium from "../views/relatorios/RelatorioPremium.vue";
import Bolao from "../views/bolao/Bolao.vue";
import ConcursoLotoJR from "../views/concursolotojr/concursoLotoJr.vue";
import ApoiadorPlanos from "../views/apoiadorplano/apoiador.vue";
import SaqueLotoJr from "../views/saquelotojr/SaqueLotoJr.vue";
import authGuard from "./auth-guard";
import accessGuard from "./access-guard";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/signin",
    name: "Signin",
    component: Login,
    beforeEnter: authGuard,
  },
  {
    path: "/seja-bem-vindo",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/reset-password",
    name: "Reset",
    component: ResetPassword,
  },
  {
    path: "/ativar-conta",
    name: "Ativar",
    component: AtivarConta,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: authGuard,
    children: [
      {
        path: "loterias",
        name: "Loterias",
        beforeEnter: accessGuard,
        component: Concurso,
      },
      {
        path: "clientes",
        name: "Clientes",
        beforeEnter: accessGuard,
        component: Clientes,
      },
      {
        path: "estatisticas",
        name: "Estatisticas",
        beforeEnter: accessGuard,
        component: Estatisticas,
      },
      {
        path: "socios",
        name: "Socios",
        beforeEnter: accessGuard,
        component: Socios,
      },
      {
        path: "concursos",
        name: "Concursos",
        beforeEnter: accessGuard,
        component: ConcursoLj,
      },
      {
        path: "empresa",
        name: "Empresa",
        beforeEnter: accessGuard,
        component: Empresa,
      },
      {
        path: "saque",
        name: "Saque",
        beforeEnter: accessGuard,
        component: Saque,
      },
      {
        path: "conciliacao",
        name: "Conciliação",
        beforeEnter: accessGuard,
        component: Conciliacao,
      },
      {
        path: "bolao",
        name: "Bolão",
        beforeEnter: accessGuard,
        component: Bolao,
      },
      {
        path: "concursolotojr",
        name: "LotoJR",
        beforeEnter: accessGuard,
        component: ConcursoLotoJR,
      },
      {
        path: "saquelotojr",
        name: "Saque LotoJR",
        beforeEnter: accessGuard,
        component: SaqueLotoJr,
      },
      {
        path: "apoiadorplano",
        name: "Planos",
        beforeEnter: accessGuard,
        component: ApoiadorPlanos,
      },
      {
        path: "padroes",
        name: "Padrões",
        beforeEnter: accessGuard,
        component: Padroes,
      },
      {
        path: "caixa",
        name: "Caixa",
        component: Caixa,
      },
      {
        path: "relatorioAposta",
        name: "Apostas",
        component: RelatorioAposta,
      },
      {
        path: "relatorioPremium",
        name: "Premium",
        component: RelatorioPremium,
      },
      {
        path: "401",
        name: "401",
        component: Forbidden,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
